import axios from "axios";
import * as tradeLicenseTypes from "../../types/admin/tradeLicenseTypes";
import {
  getAuthConfigAndCompanyId,
  handleApiError,
} from "../../../utils/authUtils";

export const getAllTradeLicensesAction = () => async (dispatch, getState) => {
  try {
    dispatch({ type: tradeLicenseTypes.GET_ALL_TRADE_LICENSE_REQUEST });

    const { companyId, config } = getAuthConfigAndCompanyId(getState());

    const { data } = await axios.get(
      // #TODO: change when needed to be a dropdown (GeneralDetailsCard) in file  production url
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/trade-license/all`,
      config
    );

    if (data.success === false) {
      throw new Error(data.message || "Failed to fetch trade licenses");
    }

    dispatch({
      type: tradeLicenseTypes.GET_ALL_TRADE_LICENSE_SUCCESS,
      payload: data?.data,
    });

    return data;
  } catch (error) {
    const err = handleApiError(error);
    dispatch({
      type: tradeLicenseTypes.GET_ALL_TRADE_LICENSE_FAIL,
      payload: err,
    });
    throw err;
  }
};

export const updateTradeLicenseAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: tradeLicenseTypes.UPDATE_TRADE_LICENSE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/trade-license/update`,
        formData,
        config
      );

      dispatch({
        type: tradeLicenseTypes.UPDATE_TRADE_LICENSE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      dispatch({
        type: tradeLicenseTypes.UPDATE_TRADE_LICENSE_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const archiveTradeLicenseAction =
  (licenseId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: tradeLicenseTypes.ARCHIVE_TRADE_LICENSE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/trade-license/archive`,
        { licenseId },
        config
      );

      dispatch({
        type: tradeLicenseTypes.ARCHIVE_TRADE_LICENSE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      dispatch({
        type: tradeLicenseTypes.ARCHIVE_TRADE_LICENSE_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const createTradeLicenseAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: tradeLicenseTypes.CREATE_TRADE_LICENSE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/trade-license/create`,
        formData,
        config
      );

      dispatch({
        type: tradeLicenseTypes.CREATE_TRADE_LICENSE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      dispatch({
        type: tradeLicenseTypes.CREATE_TRADE_LICENSE_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const deleteExpiredTradeLicenseAction =
  (licenseId, expiredLicenseId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: tradeLicenseTypes.DELETE_EXPIRED_TRADE_LICENSE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/trade-license/${licenseId}/del-specific-expire-history/${expiredLicenseId}`,
        config
      );

      dispatch({
        type: tradeLicenseTypes.DELETE_EXPIRED_TRADE_LICENSE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      dispatch({
        type: tradeLicenseTypes.DELETE_EXPIRED_TRADE_LICENSE_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const bulkAssignTradeLicenseAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: tradeLicenseTypes.BULK_ASSIGN_TRADE_LICENSE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/trade-license/bulk-assign`,
        formData,
        config
      );

      dispatch({
        type: tradeLicenseTypes.BULK_ASSIGN_TRADE_LICENSE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      dispatch({
        type: tradeLicenseTypes.BULK_ASSIGN_TRADE_LICENSE_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const deleteTradeLicenseAction =
  (oldLicenseId, newLicenseId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: tradeLicenseTypes.DELETE_TRADE_LICENSE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const payload = { oldLicenseId };
      if (newLicenseId) {
        payload.newLicenseId = newLicenseId; // Add only if present
      }
      const { data } = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/trade-license/delete`,
        {
          ...config,
          data: payload,
        }
      );
      console.log({ data });
      dispatch({
        type: tradeLicenseTypes.DELETE_TRADE_LICENSE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.error[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      dispatch({
        type: tradeLicenseTypes.DELETE_TRADE_LICENSE_FAIL,
        payload: err,
      });
      throw err;
    }
  };
